import { version } from '../../package.json';

export const environment = {
  userPoolId: 'eu-central-1_ZfcbVS02Q',
  userPoolWebClientId: '1m0n5q1g9vknr0d2n3cmset48d',
  version: version + '-prod',
  privateApiUrl: 'https://api.eatcamplove.de/inspire',
  eatcamploveUrl: 'https://www.eatcamplove.de',
  cloudfrontUrl: 'https://dfb0f1xkq6a9i.cloudfront.net',
  inspireUrl: 'https://inspire.eatcamplove.de',
};

